module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    attrs: {
      "id": "background-image"
    }
  }), _vm._v(" "), _c('app-navigation'), _vm._v(" "), _c('key-events'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.loading) ? [_c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "loading__spinner"
  }, [_c('div', {
    staticClass: "loading__bounce1"
  }), _vm._v(" "), _c('div', {
    staticClass: "loading__bounce2"
  }), _vm._v(" "), _c('div', {
    staticClass: "loading__bounce3"
  })])])] : _vm._e()], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transitionName
    }
  }, [_c('router-view', {
    staticClass: "view"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5930af97","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 84
// module chunks = 0